<template>
  <div class="row">
    <div class="col-md-12">
      <div class="card card-custom gutter-b">
        <!--begin::Header-->
        <div class="card-header border-0 pt-5">
          <h3 class="card-title align-items-start flex-column">
            <span class="card-label font-weight-bolder text-dark">
              Exibindo 2 Movimentações (Total de 2)
            </span>
            <span class="text-muted mt-3 font-weight-bold font-size-sm">
              Acompanhe em tempo real todos as movimentações cadastradas pelo seu estabelecimento
            </span>
          </h3>
          <div class="card-toolbar">
            <div class="input-icon h-40px">
              <input
                type="text"
                class="form-control form-control-lg form-control-solid h-40px"
                v-model="buscar"
                placeholder="Buscar..."
              />
              <span>
                <span class="svg-icon svg-icon-lg">
                  <!--begin::Svg Icon-->
                  <inline-svg src="media/svg/icons/General/Search.svg" />
                  <!--end::Svg Icon-->
                </span>
              </span>
            </div>
          </div>
        </div>
        <!--end::Header-->
        <!--begin::Body-->
        <div
          @scroll="handleScroll"
          class="card-body pt-2 pb-0"
          style="max-height: 418px; overflow-y: auto; overflow-x: auto"
        >
          <!--begin::Table-->
          <div class="table-responsive" style="overflow-x: initial">
            <b-table striped hover :items="items" :fields="fields">
            </b-table>
          </div>
          <!--end::Table-->
        </div>
        <!--end::Body-->
      </div>
    </div>
  </div>
</template>

<script>
import { SET_BREADCRUMB } from "@/core/services/store/breadcrumbs.module";
import { mapGetters } from "vuex";

export default {
  name: "Movimentacoes",
  data() {
    return {
      buscar: "", 
      items: [
        {
          DATA: '21/02/2022',
          PRODUTO: 'Agulha',
          LOTE: '132323',
          MARCA: 'JOHNSON',
          NUMERO_SERIE: '123456',
          TP_MOVIMENTO: 'Entrada',
          ESTOQUE: 'Almoxarifado',
          QT_FISICA: '1',
          QT_FINANCEIRA: '1',
          VALOR_UNITARIO: '100',
          EMITENTE: 'Indústria TASK Produtos'
        },
        {
          DATA: '22/02/2022',
          PRODUTO: 'Caneta',
          LOTE: '132355',
          MARCA: 'BIC',
          NUMERO_SERIE: '654321',
          TP_MOVIMENTO: 'Entrada',
          ESTOQUE: 'Almoxarifado',
          QT_FISICA: '1',
          QT_FINANCEIRA: '1',
          VALOR_UNITARIO: '100',
          EMITENTE: 'Indústria TASK Produtos'
        }
      ],
      fields: [
        {
          key: 'DATA',
          label: 'Data',
          sortable: true
        },
        {
          key: 'PRODUTO',
          label: 'Produto',
          sortable: true
        },
        {
          key: 'LOTE',
          label: 'Lote',
          sortable: true
        },
        {
          key: 'MARCA',
          label: 'Marca',
          sortable: true
        },
        {
          key: 'NUMERO_SERIE',
          label: 'Número de Série',
          sortable: true
        },
        {
          key: 'TP_MOVIMENTO',
          label: 'Tipo de Movimento',
          sortable: true
        },
        {
          key: 'ESTOQUE',
          label: 'Estoque',
          sortable: true
        },
        {
          key: 'QT_FISICA',
          label: 'Quantidade Física',
          sortable: true
        },
        {
          key: 'QT_FINANCEIRA',
          label: 'Quantidade Financeira',
          sortable: true
        },
        {
          key: 'VALOR_UNITARIO',
          label: 'Valor Unitário',
          sortable: true
        },
        {
          key: 'EMITENTE',
          label: 'Emitente',
          sortable: true
        }
      ]
    };
  },
  mounted() {
    this.$store.dispatch(SET_BREADCRUMB, [
      { title: "Stock", route: "movimentacoesestoque" },
      { title: "Movimentações de Estoque" }
    ]);
  },
  computed: {
    ...mapGetters(["verificado", "fgModoPR"])
  },
  methods: {
    handleScroll() {

    }
  }
};
</script>
